import React from "react";
import AnnouncementTicker from "./AnnouncementTicker";

const FooterStrip = ({ logo, altText = "Logo", colorSettings, announcements }) => {
  const backgroundColor = colorSettings?.backgroundColor || "white";
  // console.log("FooterStrip received announcements:", announcements);

  return (
    <div
      className="bg-white text-[rgb(33,37,41)] m-0 p-0 flex w-full items-center justify-between box-border border-t border-gray-200"
      style={{ backgroundColor }}
    >
      <div className="flex justify-center pl-2 pb-2 items-center">
        <img
          src={logo}
          alt={altText}
          className="w-[14svh]"
        />
      </div>

      {/* Center Announcement Ticker */}
      <div className="flex-1 text-center px-2 overflow-hidden">
        <AnnouncementTicker announcements={announcements} />
      </div>
    </div>
  );
};

export default FooterStrip;